import { render, staticRenderFns } from "./parametre.vue?vue&type=template&id=6245a426&"
import script from "./parametre.vue?vue&type=script&lang=js&"
export * from "./parametre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports